import React from 'react';
import Grid from '@mui/material/Grid';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';

import { closeDialog } from '../../actions/dialog';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      buttons = [],
      callback
    },
  },
}) => ({
  buttons,
  callback
});

const mapDispatchToProps = {
  closeDialog
};

const mergeProps = (state, dispatchers, ownProps) => ({
  ...state,
  ...dispatchers,
  ...ownProps,
  callback: (id) => {
    state.callback(id);
    dispatchers.closeDialog();
  }
});

const styles = {
  gridItem: {
    display: 'flex',
    flexGrow: 1,
    minHeight: 105,
    borderColor: 'red',
    borderWidth: 2
  }
};

const DialogCallBackButton = ({ buttons, callback, classes }) =>
  <Grid container spacing={3} justifyContent="center">
    {buttons.map((e) =>
      <Grid
        item sm={4}
        key={`${e.name}-${e._id}`}
        className={classes.gridItem}>
        <Button
          fullWidth
          color="primary"
          style={e.color ? { backgroundColor: e.color[500] } : {}}
          variant="contained"
          children={e.name}
          onClick={() => callback(e._id)}/>
      </Grid>
    )}
  </Grid>;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withStyles(DialogCallBackButton, styles));
